import { createFile } from '#apps/client-web/features/file-storage/helpers';
import { type FileContent } from '#apps/client-web/features/file-storage/services/file-storage';
import { parseIntOrUndefined } from '#apps/client-web/utils/helpers';

import { type Attachment } from '#packages/data-collection/models/common/attachment';
import { type AuditWaterFixtureFormEntry } from '#packages/data-collection/models/audit-water-fixture-form';

import { type EditAuditFormWaterFixtureEntryData } from './types';

export const fromFormData = (
  formData: EditAuditFormWaterFixtureEntryData,
  attachments?: Attachment[],
): Omit<AuditWaterFixtureFormEntry, 'manufactureDate'> & {
  manufactureDate?: string;
} => ({
  section: formData.section,
  room: formData.room,
  fixtureType: formData.fixtureType,
  quantity: parseIntOrUndefined(formData.quantity),
  usageRate: parseIntOrUndefined(formData.usageRate),
  unit: formData.unit,
  comments: formData.comments,
  attachments,
});

export const toFormData = (
  entryData: AuditWaterFixtureFormEntry | undefined,
  files?: (FileContent | undefined)[],
): Partial<EditAuditFormWaterFixtureEntryData> => ({
  section: entryData?.section,
  room: entryData?.room,
  fixtureType: entryData?.fixtureType,
  quantity: entryData?.quantity?.toString(),
  usageRate: entryData?.usageRate?.toString(),
  unit: entryData?.unit,
  comments: entryData?.comments,
  attachments: entryData?.attachments?.map((attachment, index) => ({
    ...attachment,
    file: createFile({
      content: files![index]!,
      name: attachment.name,
      mimeType: attachment.mimeType,
    }),
  })),
});
